import React from 'react'

export const CardWithImage = ({ image, accion }) => {
    return (<div className="cardImageComponent" onClick={() => accion()}>
        <img src={image} alt="" />
    </div>)
}
